var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('input',{ref:"clone",staticClass:"row",attrs:{"readonly":""},domProps:{"value":_vm.cpValue},on:{"focus":function($event){return $event.target.select()}}}),_c('button',{staticClass:"btn bg-light",on:{"click":_vm.cpToClipboard}},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }